import { Route, Routes } from "react-router-dom";
import BlogPage from "../Pages/BlogPage";
import HomePage from "../Pages/HomePage";
import LegalDocumentPage from "../features/legal/components/LegalDocumentPage";
import { termsContent } from "../features/legal/content/termsContent";
import { privacyContent } from "../features/legal/content/privacyContent";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/blog-yazilari/*" element={<BlogPage />} />
      <Route
        path="/hukum-ve-kosullar"
        element={<LegalDocumentPage document={termsContent} type="terms" />}
      />
      <Route
        path="/gizlilik-sozlesmesi"
        element={<LegalDocumentPage document={privacyContent} type="privacy" />}
      />
    </Routes>
  );
};

export default AppRoutes;
